export const PARTNER_TITLES = {
  Bay: 1,
  Bayan: 2,
};

export const PARTNER_TYPES = {
  Kiracı: 1,
  "Lojman Kiracısı": 2,
  "Kreş Öğrencisi": 3,
  Veli: 4,
};

export const TENANT_TYPES = {
  Kişi: 1,
  Kurum: 2,
};

export const GENDERS = {
  MALE: "Erkek",
  FEMALE: "Kız",
};

export const DEED_SEQUENCE = {
  PRESENT_INFORMATION: "Mevcut Bilgi",
  CLASSIFICATION: "Sınıflandırma",
};

export const TIME_OBJECTS = {
  YEAR: "Yıl",
  MONTH: "Ay",
  WEEK: "Hafta",
  DAY: "Gün",
};

export const CONDITION_PURPOSES = {
  Gerçekleşen: 1,
  "Tek Seferlik": 2,
  İstatiksel: 3,
};

export const CURRENCY = {
  TURKISH_LIRA: "₺",
  US_DOLLAR: "$",
  EURO: "€",
};

export const ALLOCATION_TYPES = {
  //Tahsis Türü
  TASK: "Görev",
  ORDER: "Sıra",
  SERVICE: "Hizmet",
};

export const HOUSING_SCORING_POINT_TYPE = {
  ACADEMIC_RANKED_STAFF: "Akademik Sıra",
  ASSIGNMENT_OF_ACADEMIC_STAFF: "Akademik Görev",
  ADMINISTRATIVE_PERSONNEL_ORDER: "İdari Sıra",
  ADMINISTRATIVE_PERSONNEL_DUTY_ALLOCATION: "İdari Görev",
  ADMINISTRATIVE_SERVICE: "İdari Hizmet",
};

export const LODGING_PAYMENT_TYPE = {
  PAID: "Ödendi",
  PARTIALLY_PAID: "Kısmen Ödendi",
  NOT_PAID: "Ödenmedi",
};

export const RENTABLE_AREA_POSITIONS = {
  EMPTY: "Boş",
  FULL: "Dolu",
};

export const PARENT_JOB_TYPE = {
  CIVIL_SERVANT: "Kamu Personeli",
  OTHER: "Diğer",
};

export const DISPLAY_MODE = {
  NEW: "new",
  READ_ONLY: "display",
  EDIT: "edit",
  COPY: "copy",
};

export const RECORD_STATE = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  DELETED: "DELETED",
};

export const CONTRACT_STATUS = {
  ACTIVE: "Etkin",
  ABOLISH: "Feshedildi",
  ENDED: "Sonlandı",
};

export const LODGING_PLACE = {
  CAMPUSOUT: "Kampüs Dışı",
  CENTER: "Merkez",
};
